import { html } from 'lit';
import { AttributeValueValidator } from '../../lib/attribute-value-validator/attribute-value-validator.js';
import { CrntElement } from '../../lib/crnt-element.js';
import { trustedCSS } from '../../lib/css/css.js';
import { CrntCheckableFormControlMixin } from '../checkable-form-control/checkable-form-control.component.js';
import CheckableFormControlStyles from '../checkable-form-control/checkable-form-control.css.js';
import RadioStyles from './radio.css.js';

const CrntCheckableFormControl = CrntCheckableFormControlMixin(CrntElement, { inputType: "radio" });
class CrntRadio extends CrntCheckableFormControl {
  constructor() {
    super(...arguments);
    this._controlNameValidator = new AttributeValueValidator({
      attributeKey: "name",
      host: this,
      required: true
    });
  }
  static {
    this.styles = [trustedCSS(CheckableFormControlStyles), trustedCSS(RadioStyles)];
  }
  static {
    this.tagName = "crnt-radio";
  }
  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    this._controls?.forEach((control) => {
      this._controlNameValidator.validate(control.name);
    });
  }
  _renderCheckedBox() {
    return html`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
				fill="currentColor"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M12 22C17.5078 22 22 17.5469 22 12C22 6.49219 17.5078 2 12 2C6.45312 2 2 6.49219 2 12C2 17.5469 6.45312 22 12 22ZM3.875 12C3.875 7.54688 7.50781 3.875 12 3.875C16.4531 3.875 20.125 7.54688 20.125 12C20.125 16.4922 16.4531 20.125 12 20.125C7.50781 20.125 3.875 16.4922 3.875 12Z"
				fill="currentColor"
			/>
		</svg> `;
  }
  _renderUncheckedBox() {
    return html`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M22 12C22 17.5469 17.5078 22 12 22C6.45312 22 2 17.5469 2 12C2 6.49219 6.45312 2 12 2C17.5078 2 22 6.49219 22 12ZM12 3.875C7.50781 3.875 3.875 7.54688 3.875 12C3.875 16.4922 7.50781 20.125 12 20.125C16.4531 20.125 20.125 16.4922 20.125 12C20.125 7.54688 16.4531 3.875 12 3.875Z"
				fill="currentColor"
			/>
		</svg>`;
  }
}

export { CrntRadio };
